export default {
	"dashboard.top.card1.title": "生效的规则",
	"dashboard.top.card2.title": "自动化规则帮助节省的费用",
	"dashboard.top.card2.tips": "该数据（统计于最近30天）通过深度数据搭建的AI算法模型计算得出，仅供参考。",
	"dashboard.top.card3.title": "自动化规则帮助提升的展示数",
	"dashboard.top.card3.units": "展示",

	"dashboard.bottom.card1.top.title": "加入的团队数量",
	"dashboard.bottom.card2.title": "团队成员",
	"dashboard.bottom.card2.button": "邀请成员",
	"dashboard.bottom.card3.title": "升级套餐",
	"dashboard.bottom.card3.subtitle": "您将会得到更多权益",
	"dashboard.bottom.card3.bottom.button": "Upgrade Now",
}
